import React from 'react';
import ReferInput from './ReferInput';

const ReferralRewards = ({ currentUser }) => {
  return (
    <div>
      <p>
        Give $10 off and get a $10 Amazon gift card when your friend/colleague purchases.
      </p>
      <ReferInput currentUser={currentUser} />
    </div>
  );
};

export default ReferralRewards;
